import { KTIcon } from "../../../../../../_metronic/helpers";

const GateConfirmModalHeader = ({
  device,
  setDevice,
  setOpenGateConfirmModal,
  listing
}) => {
  return (
    <div className="modal-header">
      {/* begin::Modal title */}
      <div>
      <h2 className="fw-bold listing_title">{listing?.gate_allowed ? device?.type === "open" ? `Open ${device?.device_label}` : `Close ${device?.device_label}` : 'Allow Gate Control'} for <span className="fw-bolder text-main">{listing.title}</span></h2>
      </div>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className="btn btn-icon btn-sm btn-active-icon-primary align-items-start align-self-start"
        data-kt-users-modal-action="close"
        onClick={() => {
          listing?.gate_allowed && setDevice(null);
          setOpenGateConfirmModal(false);
        }}
        style={{ cursor: "pointer" }}
      >
        <KTIcon iconName="cross" className="fs-1" />
      </div>
      {/* end::Close */}
    </div>
  );
};

export { GateConfirmModalHeader };
